// @flow

import isEmail from 'validator/lib/isEmail';

export const email = (errorMessage: string) => (value: string) => (
  value && isEmail(value)
    ? undefined
    : (errorMessage || 'Invalid email')
);

export default null;
